import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export function useMeta() {
  return useQuery({
    queryKey: ["meta"],
    queryFn: async () => (await api.get("/submissions/meta")).data,
    staleTime: Infinity,
  });
}

export function useDirectory() {
  return useQuery({
    queryKey: ["directory"],
    queryFn: async () => (await api.get("/users/directory")).data.items,
    staleTime: 5 * 60_000,
  });
}
